<script>
	export let className = '';
	export let style = '';
</script>

<svg
	class={className}
	{style}
	width="21"
	height="18"
	fill="none"
	xmlns="http://www.w3.org/2000/svg"
>
	<path
		d="M20.526 1.5 11 18 1.474 1.5h19.052Z"
		fill="#B0E4DD"
		stroke="url(#a)"
		stroke-width="1.5"
	/>
	<defs>
		<linearGradient
			id="a"
			x1="23.5"
			y1="15.579"
			x2="-5.047"
			y2="11.059"
			gradientUnits="userSpaceOnUse"
		>
			<stop offset=".13" stop-color="#00B99F" />
			<stop offset="1" stop-color="#37D22F" />
		</linearGradient>
	</defs>
</svg>
